import { localStorageAvailable } from '@utils/localStorage';

const CBT_CONFIG_STORAGE_KEY = 'cbtConfig';

export const getOfflineCbtGoalUid = (cbtConfig) =>
  cbtConfig?.cbtOfflineGoalProgramMap?.cbtGoalUid ?? null;

export const getCbtOfflineProgrammeUid = (cbtConfig) =>
  cbtConfig?.cbtOfflineGoalProgramMap?.programUid ?? null;

export const isCbtVenueConfigReady = (cbtConfig) =>
  !!(getOfflineCbtGoalUid(cbtConfig) && getCbtOfflineProgrammeUid(cbtConfig));

export const OFFLINE_CBT_ADDON_HELPER_TEXT =
  'Centre selection is available after adding a test combo.';

export const getCbtActivationDelayMessage = (activationDelayHours) => {
  if (!activationDelayHours) return null;

  return `You will get access to the test series within ${activationDelayHours} hours`;
};

export const isOfflineCbtAddon = (bundle, cbtConfig) => {
  const offlineCbtGoalUid = getOfflineCbtGoalUid(cbtConfig);
  if (!bundle || !offlineCbtGoalUid || !isCbtVenueConfigReady(cbtConfig)) {
    return false;
  }

  return bundle.topology_details?.some(
    (topology) => topology.uid === offlineCbtGoalUid
  );
};

const isNonEmptyCbtConfig = (cbtConfig) =>
  !!cbtConfig &&
  typeof cbtConfig === 'object' &&
  Object.keys(cbtConfig).length > 0;

const getCbtGoalUidsToHide = (cbtConfig) => {
  if (!cbtConfig) {
    return [];
  }

  return [
    cbtConfig?.cbtOfflineGoalProgramMap?.cbtGoalUid,
    cbtConfig?.cbtOnlineGoalProgramMap?.cbtGoalUid
  ].filter(Boolean);
};

export const persistCbtConfigIfValid = (cbtConfig) => {
  if (!localStorageAvailable() || !isNonEmptyCbtConfig(cbtConfig)) {
    return;
  }

  localStorage.setItem(CBT_CONFIG_STORAGE_KEY, JSON.stringify(cbtConfig));
};

export const getPersistedCbtGoalUidsToHide = () => {
  if (!localStorageAvailable()) {
    return [];
  }

  try {
    const stored = localStorage.getItem(CBT_CONFIG_STORAGE_KEY);
    return getCbtGoalUidsToHide(stored ? JSON.parse(stored) : null);
  } catch {
    return [];
  }
};
